var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFaucetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 44,
    stroke: "#fff",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 82a34 34 0 1 0 0-68 34 34 0 0 0 0 68Zm9.7-42.58a3.3 3.3 0 0 1 3.14 0l10.61 6.19a3.26 3.26 0 0 1 1.57 2.76v12.5c0 1.18-.65 2.23-1.57 2.76l-10.61 6.2a3.3 3.3 0 0 1-3.14 0l-10.61-6.2a3.26 3.26 0 0 1-1.57-2.76v-4.35l4.98-2.9v4.22c0 1.17.65 2.23 1.57 2.76l5.64 3.29a3.3 3.3 0 0 0 3.14 0l5.5-3.3a3.26 3.26 0 0 0 1.57-2.75v-6.58c0-1.18-.65-2.24-1.57-2.77l-5.63-3.29a3.3 3.3 0 0 0-3.14 0l-7.2 4.21-4.98 2.9-7.2 4.21a3.3 3.3 0 0 1-3.14 0l-10.62-6.19a3.26 3.26 0 0 1-1.57-2.76V35.21c0-1.04.53-2.1 1.57-2.63l10.74-6.32a3.3 3.3 0 0 1 3.14 0l10.47 6.19a3.26 3.26 0 0 1 1.57 2.76v4.47l-4.98 2.9v-4.35c0-1.18-.65-2.24-1.57-2.76l-5.63-3.43a3.3 3.3 0 0 0-3.14 0l-5.63 3.29a3.26 3.26 0 0 0-1.57 2.76v6.58c0 1.18.65 2.24 1.57 2.77l5.63 3.42a3.3 3.3 0 0 0 3.14 0l7.2-4.33 4.98-2.76 7.34-4.35Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFaucetIcon);
export default __webpack_public_path__ + "static/media/menu-faucet-icon.436e25c0cace5de9d8a945a067728629.svg";
export { ForwardRef as ReactComponent };